<template>
  <div>
    <div class=" container-fluid   ">
      <div class="llp-container-section  heightcontainer ">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="performance"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white">
              <span><b> View Dashboard</b></span>
            </nav>
            <div style="width:40%;" class="sidebyside">
              <center>
                <highcharts :options="perfchartOptions"></highcharts>
              </center>
            </div>
            <template v-if="hideGraphs == false">
              <div style="width:55%;" class="sidebyside">
                <highcharts :options="busvolchartOptions"></highcharts>
              </div>
              <div style="width:40%;" class="sidebyside">
                <highcharts :options="busperfchartOptions"></highcharts>
              </div>
              <div style="width:30%;" class="sidebyside">
                <highcharts :options="goalcompchartOptions"></highcharts>
              </div>
              <div style="width:30%;" class="sidebyside">
                <highcharts :options="revenueChartOptions"></highcharts>
              </div>
            </template>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpdeal from '../js/http-dealstracking.js'
export default {
  components: { MainMenu, TopHeader, BottomFooter },
  mounted () {
    this.fetchData(), this.myFunction()
    this.menuheight()
  },
  methods: {
    fetchData () {
      this.retrieveScoreDashboard()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#performance').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    retrieveScoreDashboard () {
      httpdeal.get('/score/dashboardsummary').then(response => {
        this.dashboardSummary = response.data
        for (var i = 0; i < this.dashboardSummary.length; i++) {
          this.perfchartOptions.series[2].data.push(
            this.dashboardSummary[i].dealsCount
          )
          this.perfchartOptions.series[1].data.push(
            this.dashboardSummary[i].applicationCount
          )
          this.perfchartOptions.series[0].data.push(
            this.dashboardSummary[i].quoteCount
          )
          this.perfchartOptions.xAxis.categories.push(
            this.dashboardSummary[i].monthName
          )
        }
        this.perfchartOptions.title.text += new Date().getFullYear()
      })
    }
  },
  data () {
    return {
      hideGraphs: true,
      dashboardSummary: [],
      perfchartOptions: {
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: 'Performance Graph from Jan '
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y} </b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          min: 0,
          title: {
            text: ' '
          }
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            pointWidth: 5
          }
        },
        series: [
          {
            name: 'Quotes',
            data: []
          },
          {
            name: 'Apps',
            data: []
          },
          {
            name: 'Deals',
            data: []
          }
        ]
      },

      busvolchartOptions: {
        chart: {
          type: 'column'
        },
        colors: ['#2b908f', '#f45b5b', '#8085e9'],
        title: {
          text: 'Business Volume by state last 3 years'
        },
        xAxis: {
          categories: [
            'State',
            'TX',
            'NY',
            'MO',
            'NY',
            'CA',
            'MI',
            'FL',
            'NC',
            'PA',
            'NV',
            'NJ',
            'AZ'
          ]
        },
        yAxis: {
          min: 0,
          title: {
            text: ' '
          }
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent',
            pointPadding: 0.2,
            borderWidth: 0,
            pointWidth: 15
          }
        },
        series: [
          {
            name: 'Series 1',
            data: [5, 3, 4, 7, 2, 5, 3, 4, 7, 2, 4, 7, 2]
          },
          {
            name: 'Series 2',
            data: [2, 2, 3, 2, 1, 5, 3, 4, 7, 2, 3, 4, 7]
          },
          {
            name: 'Series 3',
            data: [3, 4, 4, 2, 5, 3, 4, 4, 2, 5, 5, 3, 4]
          }
        ]
      },

      busperfchartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Business Performance by state'
        },
        xAxis: {
          categories: ['Dealers Count', 'Apps Count', 'Deals Count']
        },
        colors: ['#058DC0', '#50B432', '#ED561B'],
        yAxis: {
          min: 0,
          title: {
            text: ' '
          }
        },
        tooltip: {
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',

            borderWidth: 0,
            pointWidth: 50
          }
        },
        series: [
          {
            name: 'FL',
            data: [5, 3, 4]
          },
          {
            name: 'GA',
            data: [2, 2, 3]
          },
          {
            name: 'CT',
            data: [3, 4, 4]
          }
        ]
      },
      goalcompchartOptions: {
        chart: {
          type: 'bar'
        },
        title: {
          text: 'Goal Completion'
        },
        xAxis: {
          categories: [
            'Add Product to cart',
            'Complete Purchases',
            'Visit Premium Plan',
            'Send enquiries',
            'Monthly purchases'
          ]
        },
        colors: ['#058DC0', '#50B432', '#ED561B', '#50B432', '#ED561B'],
        yAxis: {
          min: 0,
          title: {
            text: ' '
          }
        },
        tooltip: {
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',

            borderWidth: 0
          }
        },
        series: [
          {
            data: [
              {
                y: 80,
                segmentColor: 'red'
              },
              {
                y: 50,
                segmentColor: 'red'
              },
              {
                y: 70,
                segmentColor: 'red'
              },
              {
                y: 65,
                segmentColor: 'green'
              },
              {
                y: 25,
                segmentColor: 'red'
              }
            ]
          }
        ]
      },

      revenueChartOptions: {
        chart: {
          type: 'column'
        },
        colors: ['#910000', '#492970'],
        title: {
          text: 'Revenue'
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y} </b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        xAxis: {
          categories: [
            '2011',
            '2012',
            '2013',
            '2014',
            '2015',
            '2016',
            '2017',
            '2018'
          ]
        },
        yAxis: {
          min: 0,
          title: {
            text: ' '
          }
        },
        plotOptions: {
          column: {
            borderWidth: 0,
            pointWidth: 3
          }
        },
        series: [
          {
            name: 'Data 1',
            data: [49, 71, 64, 29, 44, 76, 10, 48]
          },
          {
            name: 'Data 2',
            data: [83, 78, 98, 93, 56, 84, 15, 64]
          }
        ]
      }
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
<style scoped>
.sidebyside {
  float: left;
}
</style>
